var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEasywebinarSoloLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 91,
    viewBox: "0 0 92 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1597880216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0766 0.279297H77.1407C81.0388 0.279297 84.7541 1.81998 87.4949 4.59321C90.2357 7.36644 91.7584 11.1257 91.7584 15.0698V75.2797C91.7584 79.2239 90.2357 82.9831 87.4949 85.7564C84.7541 88.5296 81.0388 90.0703 77.1407 90.0703H15.0766C11.1786 90.0703 7.46327 88.5296 4.72247 85.7564C1.98166 82.9831 0.458984 79.2239 0.458984 75.2797V15.0698C0.458984 11.1257 1.98166 7.36644 4.72247 4.59321C7.46327 1.81998 11.1786 0.279297 15.0766 0.279297Z",
    fill: "#22B060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1245 18.582L81.3413 18.7669C81.3413 18.7669 62.2775 44.8353 81.5849 71.828H67.9418C67.9418 71.828 58.1967 63.3235 57.9531 46.1294C57.9531 46.1294 57.6485 29.1203 68.1245 18.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4984 18.582L57.7152 18.7669C57.7152 18.7669 38.5905 44.8353 57.9589 71.828H44.3157C44.3157 71.828 34.5706 63.3235 34.327 46.1294C34.2661 46.1294 33.9615 29.1203 44.4984 18.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8016 18.582L34.0184 18.7669C34.0184 18.7669 14.8937 44.8353 34.262 71.828H20.558C20.558 71.828 10.8129 63.3235 10.5693 46.1294C10.5693 46.1294 10.2647 29.1203 20.8016 18.582Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasywebinarSoloLogo);
export default __webpack_public_path__ + "static/media/easywebinar-solo-logo.410197987a9a8763fc78d67db2555595.svg";
export { ForwardRef as ReactComponent };